module.exports = __webpack_public_path__ + "default-profile.png?af1cc9bec6cb019eac7b1a7e0e65830d";